import { ref } from 'vue'
import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

export const appInForeground = ref(true)

export function isAppInForeground(): boolean {
  return appInForeground.value
}

if (Capacitor.isNativePlatform()) {
  void App.addListener('appStateChange', ({ isActive }) => {
    appInForeground.value = isActive
  })
}
